import React, { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";

import Accordion from "react-bootstrap/Accordion";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { colors } from "utils/styles";
import Text from "@components/Reusables/Text";
import Title from "@components/Reusables/Title";
import DynamicLink from "@components/Reusables/DynamicLink";

export default function MobileSubNav(props = {}) {
	const { navigation = [], withScroll } = props;
	const router = useRouter();
	const mobileNavRef = useRef();
	const [activeKey, setActiveKey] = useState("0");

	let path = router.asPath.split("/page")[0];
	path = path.split("?")[0];
	path = path.split("#")[0];

	function findPath(navigation) {
		return navigation.find((nav) => {
			if (nav.items) {
				return findPath(nav.items);
			} else {
				return nav.link === path;
			}
		});
	}

	const navItem = findPath(navigation);

	useEffect(() => {
		const handleRouteChangeComplete = (url) => {
			setActiveKey(null);
		};
		const handleBeforeHistoryChange = (path) => {
			const navItem = findPath(navigation);

			if (!navItem) return;
			// window.scrollTo(0, 650);
		};
		// router.events.on("routeChangeComplete", handleRouteChangeComplete);
		router.events.on("beforeHistoryChange", handleBeforeHistoryChange);

		return () => {
			// router.events.off("routeChangeComplete", handleRouteChangeComplete);
			router.events.off("beforeHistoryChange", handleBeforeHistoryChange);
		};
	}, []);

	// if (!navItem) {
	// 	console.error("no nav item");
	// 	return <></>;
	// }
	return (
		<Accordion className={`mobile-sub-nav `} activeKey={activeKey}>
			<Accordion.Item className={``} eventKey={"main"} key={"main"}>
				<Accordion.Header
					className={``}
					ref={mobileNavRef}
					onClick={() => setActiveKey((key) => (key === "main" ? null : "main"))}
				>
					<Row className=" align-items-center w-100 ">
						{navigation.title && (
							<Col className="" xs={"auto"}>
								<Title
									className="mb-0 text-center"
									color={colors.white}
									text={navigation.title}
									element="h3"
								/>
							</Col>
						)}

						<Col className="justify-content-center justify-content-sm-end me-5 d-flex" xs={true}>
							<Text
								display="block"
								size="20"
								text={navItem?.name}
								decoration="underline"
								marginBottom="0"
							/>
						</Col>
					</Row>
				</Accordion.Header>
				<Accordion.Body>
					{navigation.map((navLink) => {
						return (
							<React.Fragment key={navLink.name}>
								{navLink.items?.length ? (
									<SubNavAccordion
										setActiveKey={setActiveKey}
										navLink={navLink}
										navItem={navItem}
										withScroll={withScroll}
									/>
								) : (
									<AccordionRow
										withScroll={withScroll}
										navItem={navItem}
										navLink={navLink}
										setActiveKey={setActiveKey}
									/>
								)}
							</React.Fragment>
						);
					})}
				</Accordion.Body>
			</Accordion.Item>
			<style global jsx>{`
				.mobile-sub-nav .accordion-item {
					border: none;
					background: none;
				}

				.mobile-sub-nav .accordion-header {
				}

				.mobile-sub-nav .accordion-body {
					background: ${colors.white};
				}

				.mobile-sub-nav .accordion-button::after {
					background-image: ${`url("data:image/svg+xml;charset=utf-8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='${encodeURIComponent(
						colors.white
					)}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>")`};
				}
				.mobile-sub-nav .accordion-button:not(.collapsed) {
					background: ${colors.lightBlue};
					color: ${colors.white};
					font-weight: bold;
				}
				.mobile-sub-nav .accordion-button.collapsed {
					background: ${colors.lightBlue};
				}
				.mobile-sub-nav .accordion-button {
					transition: all 0.5s;
					color: ${colors.white};
					font-weight: bold;
					padding: 5px;
				}

				.mobile-sub-nav .mobile-nav-link:hover {
					color: ${colors.green};
				}
				.mobile-sub-nav .mobile-nav-link.active {
					color: ${colors.green};
				}
			`}</style>

			<style jsx="true">{``}</style>
		</Accordion>
	);
}

function AccordionRow(props) {
	const { navItem, navLink, setActiveKey, withScroll } = props;

	// return <></>;
	return (
		<Row
			className="ms-4 g-0"
			onClick={() => {
				// mobileNavRef.current.click();
				setActiveKey(null);
			}}
		>
			{navItem?.link === navLink?.link && (
				<Col xs="auto">
					<FontAwesomeIcon color={colors.green} icon={faChevronRight} className="w-10px me-3 inline-flex" />
				</Col>
			)}
			<Col className={`${navItem?.link !== navLink?.link ? "ps-4 " : ""} `}>
				<Link scroll={withScroll} href={navLink?.link}>
					<Text
						className={`mobile-nav-link  d-block ${navItem?.link == navLink?.link ? " active " : ""}`}
						size="20"
						weight="bold"
						text={navLink?.name}
					/>
				</Link>
			</Col>
		</Row>
	);
}

function SubNavAccordion(props) {
	const { navItem, navLink, setActiveKey, withScroll } = props;

	return (
		<Accordion className={`mobile-nested-sub-nav boxShadow ms-5 mb-2`}>
			<Accordion.Item className={``} eventKey={"main"} key={"main"}>
				<Accordion.Header
					className={``}
					// onClick={() => setActiveKey((key) => (key === "main" ? null : "main"))}
				>
					<Row className="  ">
						<Col className=" justify-content-start d-flex" xs={true}>
							<Text
								display="block"
								size="20"
								text={props.navLink?.name}
								decoration="underline"
								marginBottom="0"
							/>
						</Col>
					</Row>
				</Accordion.Header>
				<Accordion.Body>
					{props.navLink.items.map((navLink) => {
						return (
							<AccordionRow
								key={navLink?.link}
								withScroll={withScroll}
								navItem={props.navItem}
								navLink={navLink}
								setActiveKey={setActiveKey}
							/>
						);
					})}
				</Accordion.Body>
			</Accordion.Item>
			<style global jsx>{`
				.mobile-nested-sub-nav .accordion-header {
				}

				.mobile-nested-sub-nav .accordion-body {
					background: ${colors.whiteGray};
				}

				.mobile-nested-sub-nav .accordion-button::after {
					background-image: ${`url("data:image/svg+xml;charset=utf-8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='${encodeURIComponent(
						colors.white
					)}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>")`};
				}
				.mobile-nested-sub-nav .accordion-button:not(.collapsed) {
					background: ${colors.lightBlue};
					color: ${colors.white};
					font-weight: bold;
				}
				.mobile-nested-sub-nav .accordion-button.collapsed {
					background: ${colors.lightBlue};
				}
				.mobile-nested-sub-nav .accordion-button {
					background: blue;
					transition: all 0.5s;
					background: ${colors.yellow};
					color: ${colors.white};
					font-weight: bold;
					padding: 5px;
				}

				.mobile-nested-sub-nav .mobile-nav-link:hover {
					color: ${colors.green};
				}
				.mobile-nested-sub-nav .mobile-nav-link.active {
					color: ${colors.green};
				}
			`}</style>
		</Accordion>
	);
}
